// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1jGub","col":"CardReaderDesc_col__2keI7","label":"CardReaderDesc_label__2efSN"};